/** Pure formatters shared by the automation approval views. */

export const humanize = (value) => String(value ?? '')
  .replace(/_/g, ' ')
  .replace(/\b\w/g, (letter) => letter.toUpperCase());

export function conditionText(condition = {}) {
  return [humanize(condition.field), humanize(condition.operator), condition.value ?? '']
    .join(' ')
    .trim();
}

export function stepDetail(config = {}) {
  if (config.subject) return config.subject;
  if (config.title) return config.title;
  if (config.campaign_name || config.template_name) {
    return config.campaign_name || config.template_name;
  }
  if (config.duration) return `${config.duration} ${config.unit || 'days'}`;
  if (config.field) {
    const branches = (config.then_actions || config.then_steps || []).length;
    return `If ${conditionText(config)} (${branches} step${branches === 1 ? '' : 's'})`;
  }
  return config.decision_prompt || '';
}

export function triggerSummary(triggerType, config = {}) {
  if (triggerType === 'account_health' && config.conditions?.length) {
    const joiner = ` ${(config.condition_logic || 'and').toUpperCase()} `;
    return config.conditions.map(conditionText).join(joiner);
  }
  if (triggerType === 'contract_renewal') {
    return `${config.days_before_renewal ?? 90} days before renewal`;
  }
  if (triggerType === 'schedule' && config.schedule) {
    const { frequency = 'daily', time = '09:00', day, day_of_month: dayOfMonth } = config.schedule;
    const when = frequency === 'weekly' ? ` on ${humanize(day)}`
      : frequency === 'monthly' ? ` on day ${dayOfMonth ?? 1}` : '';
    return `${humanize(frequency)}${when} at ${time} UTC`;
  }
  return '';
}
